/* eslint-disable */
import React, { useState } from "react";
import "./sourceOfMeetBanner.scss";
// localizations
import { withTranslation, useTranslation } from "react-i18next";
// import Redux
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "../../layout-one/js/assets/images/closeBtn.svg";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

function SourceOfMeetBanner(props) {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  
  const handleClose = () => {
    appDispatch({ type: "setSourceOfMeetBanner", sourceOfMeetBannerImage: false });
    setOpen(false);
  };

  const onLoad = () => {
      setOpen(true);
  };

  // Get the image URL - handle both string and array formats
  const imageUrl = Array.isArray(appState.sourceOfMeetBannerImageUrls) 
    ? appState.sourceOfMeetBannerImageUrls[0] 
    : appState.sourceOfMeetBannerImageUrls;

  return (
    imageUrl && (
      <>
        <div
          id="mySidenav"
          className={`promotionBannerPopup col-xl-5 py-3   ${
            appState.langValue == "ar" ? "promotionBannerPopupArabic" : " "
          }`} 
        >    
          {
            <Dialog
              style={open ? {} : { display: "none" }}
              className="classToTargetsomModal"
              open={appState.sourceOfMeetBannerImage}
              onClose={handleClose}
            >
              <DialogContent className="p-0">
                <button
                  type="button"
                  onClick={handleClose}
                  className="close pb-1"
                >
                  <span aria-hidden="true">
                    <img src={CloseIcon} alt="CloseIcon" />
                  </span>
                </button>
                
                {/* Single Image Display */}
                <div className="custom-gallery-container">
                  <div className="gallery-slider">
                          <div
                      className={`gallery-slide active ${appState.langValue === "ar" ? "directionRtl" : ""}`}
                          >
                            <img
                              className="gallery-image"
                        src={imageUrl}
                        alt="Source of Meet"
                        onLoad={onLoad}
                            />
                          </div>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          }
        </div>
      </>
    )
  );
}

export default withTranslation()(SourceOfMeetBanner);
